class Neworder {
  id;
  orderNumber;
  transactionNumber;
  name;
  phoneNumber;
  city;
  status;
  constructor(
    orderNumber,
    transactionNumber,
    name,
    phoneNumber,
    city,
    status,
    id
  ) {
    this.orderNumber = orderNumber;
    this.transactionNumber = transactionNumber;
    this.name = name;
    this.phoneNumber = phoneNumber;
    this.city = city;
    this.status = status;
    this.id = id;
  }
  getId() {
    return this.id;
  }
}
class Order {
  id;
  orderNumber;
  transactionNumber;
  name;
  phoneNumber;
  city;
  status;
  constructor(
    orderNumber,
    transactionNumber,
    name,
    phoneNumber,
    city,
    status,
    id
  ) {
    this.orderNumber = orderNumber;
    this.transactionNumber = transactionNumber;
    this.name = name;
    this.phoneNumber = phoneNumber;
    this.city = city;
    this.status = status;
    this.id = id;
  }
  getId() {
    return this.id;
  }
}
class logorder {
  name;
  status;
  orderNumber;
  orderdate;
  statusInput;
  reciver;
  phoneNumber;
  postalcode;
  city;
  address;
  totalAmount;
  paymentMethod;
  transactionNumber;
  Amount;
  deliverycost;
  deliverycode;
  constructor(
    id,
    name,
    status,
    orderNumber,
    orderdate,
  
    reciver,
    phoneNumber,
    postalcode,
    city,
    address,
    totalAmount,
    paymentMethod,
    transactionNumber,
    Amount,
    deliverycost,
    deliverycode
  ) {
    this.id=id;
    this.name=name;
    this.status=status;
    this.orderNumber=orderNumber;
    this.orderdate=orderdate;

    this.reciver=reciver;
    this.phoneNumber=phoneNumber;
    this.postalcode=postalcode;
    this.city=city;
    this.address=address;
    this.totalAmount=totalAmount;
    this.paymentMethod=paymentMethod;
    this.transactionNumber=transactionNumber
    this.Amount=Amount;
    this.deliverycost=deliverycost;
    this.deliverycode=deliverycode
  }
  getId() {
    return this.id;
  }
}
class OrderTable {
  id;
  productName;
  number;
  amount;
  cost;
  constructor(id,productName,number,amount,cost){
    this.id=id;
    this.productName=productName;
    this.number=number;
    this.amount=amount;
    this.cost=cost;
  }

  getId() {
    return this.id;
  }
}

class OrderAddTable {
  id;
  productName;
  number;
  amount;
  cost;
  constructor(id,productName,number,amount,cost){
    this.id=id;
    this.productName=productName;
    this.number=number;
    this.amount=amount;
    this.cost=cost;
  }
  getId() {
    return this.id;
  }
}
export {OrderTable}
export { Neworder };
export { Order };
export {logorder};
export {OrderAddTable}
